module.exports = __webpack_public_path__ + "img/Banner5英文.cb4c6fdf.png";